/* eslint-disable */
// @ts-nocheck
import algoliasearch from "algoliasearch";
import instantsearch from "instantsearch.js";
import {
  hits,
  infiniteHits,
  refinementList,
  hierarchicalMenu,
  panel,
  index,
  clearRefinements,
  configure,
} from "instantsearch.js/es/widgets";
import { connectAutocomplete } from "instantsearch.js/es/connectors";

const searchInit = () => {
  const navigation = document.querySelector(".navigation-main");
  const toggler = document.querySelector(".search-container__open-search");
  const searchEl = document.querySelector(".search-container");
  const input = document.querySelector(".search-container__input");
  const modal = document.querySelector(".search-container__modal");
  const closeSearch = document.querySelector(".search-container__close-search");
  const searchButton = document.querySelector("#search-container-button");
  const langSwitcher = document.querySelector(".language-switch__button");

  const body: HTMLElement = document.querySelector("body");
  const language = body.dataset.languageCode;

  searchButton.addEventListener("click", () => {
    searchEl.querySelector("form").submit();
  });

  toggler.addEventListener("click", (e) => {
    e.preventDefault();
    navigation.classList.toggle("navigation-main--search-active");
    searchEl.classList.toggle("search-container--active");
  });

  input.addEventListener("keypress", (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      searchEl.querySelector("form").submit();
    }
  });

  input.addEventListener("keyup", (e) => {
    search.helper.setQuery(e.target.value).search();
    modal.classList.add("search-container__modal--active");
  });

  input.addEventListener("click", (e) => {
    modal.classList.add("search-container__modal--active");
  });

  langSwitcher.addEventListener("click", (e) => {
    modal.classList.remove("search-container__modal--active");
  });

  document.addEventListener("click", (e) => {
    if (e.target.closest(".search-container")) {
      return;
    } else {
      modal.classList.remove("search-container__modal--active");
    }
  });

  closeSearch.addEventListener("click", () => {
    navigation.classList.toggle("navigation-main--search-active");
    searchEl.classList.toggle("search-container--active");
  });

  const searchClient = algoliasearch(
    "W6YNCB26YE",
    "a65f35d558a527f50254704f7dd6639f"
  );

  const search = instantsearch({
    indexName: "wp_posts_products",
    searchClient,
  });

  const renderKeywords = ({ indexId, hits }) => {
    let count = 0;

    return hits
      .map((hit: any) => {
        if (count <= 3) {
          count = count + 1;
          return `
            <li>
              <a href="${hit.permalink}">
                ${hit.post_title}
              </a>
            </li>`;
        }
      })
      .join("");
  };

  const renderSolutions = ({ indexId, hits }) => {
    let count = 0;

    return hits
      .map((hit: any) => {
        if (count <= 2 && hit.parent_id == 0) {
          count = count + 1;
          return `
            <li>
              <a href="${hit.permalink}">
                <img src="${hit.solutions_setttings_image}">
                ${hit.name}
              </a>
            </li>`;
        }
      })
      .join("");
  };

  const renderProducts = ({ indexId, hits }) => {
    let count = 0;

    return hits
      .map((hit: any) => {
        if (count <= 3) {
          count = count + 1;
          if (typeof hit.products_settings_text == "undefined") {
            hit.products_settings_text = "";
          }
          return `
          <a href="${hit.permalink}" class="search-product-card">
            <div class="search-product-card__symbol">
              <p class="search-product-card__symbol-text">ao</p>
            </div>
            <h2 class="search-product-card__title">
              ${hit.post_title}
            </h2>
            <p class="search-product-card__content">
              ${hit.products_settings_text}
            </p>
          </a>`;
        }
      })
      .join("");
  };

  // Create the render function
  const renderAutocomplete = (renderOptions, isFirstRender) => {
    const { indices, currentRefinement, refine, widgetParams } = renderOptions;
    let total: number = 0;

    indices.forEach((index: any) => {
      if (
        index.indexId == "wp_terms_solutions" ||
        index.indexId == "wp_posts_products"
      ) {
        document
          .querySelector("#search-categories-autocomplete")
          .querySelector("ul").innerHTML = renderKeywords(index);
      }

      if (index.indexId == "wp_terms_solutions") {
        if (index.hits.length == 0) {
          if (document.querySelector(".search-container__solutions") != null) {
            document.querySelector(
              ".search-container__solutions"
            ).style.display = "none";
          }
        } else {
          document.querySelector(".search-container__solutions").style.display =
            "block";
          document
            .querySelector("#search-solutions")
            .querySelector("ul").innerHTML = renderSolutions(index);
          total += index.hits.length;
        }
      }

      if (index.indexId == "wp_posts_products") {
        document
          .querySelector("#search-products")
          .querySelector("ul").innerHTML = renderProducts(index);
        total += index.hits.length;
      }
    });

    document.querySelector(
      "#search-container-button span"
    ).innerHTML = `(${total})`;
  };

  // Create the custom widget
  const customAutocomplete = connectAutocomplete(renderAutocomplete);

  // Instantiate the custom widget
  search.addWidgets([
    configure({
      facetFilters: ["wpml.locale:" + language],
    }),

    index({ indexName: "wp_searchable_posts" }),
    index({ indexName: "wp_terms_solutions" }),
    index({ indexName: "wp_posts_products" }),

    customAutocomplete({}),
  ]);

  search.start();
};

export default searchInit;
